<template>
  <v-dialog
    width="600"
    v-model="opened"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @keydown.esc="$emit('update:opened', false)"
    persistent
    v-if="selectedQuestion"
  >
    <v-card
      flat
      @drop.prevent="addFile"
      @dragover.prevent
      v-if="selectedQuestion.options"
    >
      <v-card-title class="title pb-0">
        {{
          isEmpty(selectedQuestion.options) ||
          selectedQuestion.options.length > 1
            ? $t('documents.uploadDocuments')
            : `Upload ${selectedQuestion.options[0]}`
        }}
      </v-card-title>
      <v-card-text>
        <v-alert
          v-if="
            !isEmpty(selectedQuestion.options) &&
              selectedQuestion.options.length > 1
          "
          :value="true"
          outline
          block
          :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
          color="primary"
          class="text-xs-left mb-2"
        >
          {{ $t('alerts.dragAndDropFiles2') }}
        </v-alert>
        <v-alert
          v-else
          :value="true"
          outline
          block
          :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
          color="primary"
          class="text-xs-left mb-2"
        >
          {{ $t('alerts.dragAndDropFiles3') }}
        </v-alert>
        <v-layout
          column
          v-if="
            selectedQuestion.options.length === 1 ||
              isEmpty(selectedQuestion.options)
          "
        >
          <v-flex class="hidden-xs-only">
            <v-layout class="drag-and-drop mt-2 mb-3" style="min-height: 200px">
              <v-layout column align-center justify-center>
                <div>
                  <v-icon>cloud_upload</v-icon>
                </div>
                <div>
                  <span @click="$emit('pick-documents')" class=""
                    >Drag and drop files here or
                    <span class="clickable primary--text">browse</span></span
                  >
                </div>
                <span>(Max Size 150MB)</span>
              </v-layout>
            </v-layout>
          </v-flex>

          <v-btn
            class="default-input primary text-capitalize hidden-sm-and-up mb-4"
            @click="$emit('pick-documents')"
          >
            {{ $t('documents.selectFiles') }}
          </v-btn>
        </v-layout>

        <v-layout column v-else>
          <div class="grey--text text--darken-2 text-xs-left mr-4">
            {{ $t('questionnaire.documentOption')
            }}{{ selectedQuestion.options.length > 1 ? 's' : '' }}
          </div>
          <v-layout align-center class="mb-4">
            <v-select
              v-model="selectedDocumentType"
              :items="selectedQuestion.options"
              placeholder="Select Document Option"
              class="default-input"
              solo
              hide-details
            />
            <v-btn
              :disabled="!selectedDocumentType"
              class="default-input primary text-capitalize hidden-xs-only"
              @click="$emit('pick-documents')"
            >
              {{ $t('documents.selectFiles') }}
            </v-btn>
          </v-layout>
          <v-btn
            :disabled="!selectedDocumentType"
            class="default-input primary text-capitalize hidden-sm-and-up mb-4"
            @click="$emit('pick-documents')"
          >
            {{ $t('documents.selectFiles') }}
          </v-btn>
        </v-layout>
        <v-layout column class="mb-4">
          <v-layout
            align-center
            :key="i"
            v-for="(document, i) in documentsToImport"
          >
            <v-icon color="primary"> insert_drive_file </v-icon>
            <v-text-field
              class="default-input mr-2"
              hide-details
              solo
              v-model="document.name"
            />
            <span>.{{ document.extension }}</span>
            <v-spacer />
            <v-icon
              @click="documentsToImport.splice(i, 1)"
              style="cursor: pointer"
              color="error"
              >cancel</v-icon
            >
          </v-layout>
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-spacer class="hidden-xs-only" />
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          class="default-input primary text-capitalize"
          @click="$emit('import-documents')"
          :disabled="isEmpty(documentsToImport) || !areAllDocumentsNamed"
          :loading="loading"
        >
          {{ $t('documents.uploadAll') }}
        </v-btn>
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          outline
          class="default-input error--text text-capitalize"
          @click="$emit('update:opened', false)"
        >
          {{ $t('cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

export default {
  props: {
    opened: {
      type: Boolean,
    },
    selectedQuestion: {
      type: Object,
      default() {
        return {
          options: [],
        };
      },
    },
    documentsToImport: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      selectedDocumentType: null,
      loading: false,
    };
  },

  methods: {
    isEmpty,
    addFile(e) {
      this.$emit('add-file', e);
    },
  },

  computed: {
    areAllDocumentsNamed() {
      return this.documentsToImport.every(d => !isEmpty(d.name));
    },
  },

  watch: {
    selectedDocumentType: {
      async handler(value) {
        this.$emit('select-document-type', value);
      },
      immediate: false,
    },
    opened: {
      handler() {
        if (this.selectedQuestion.options.length === 1) {
          this.selectedDocumentType = this.selectedQuestion.options[0];
        }
      },
    },
  },
};
</script>

<style lang="postcss" scoped>
.drag-and-drop {
  height: 140px;
  border-radius: 4px;
  background: #eee;
  border: 1px solid rgba(0, 0, 0, 0.15);

  & >>> i {
    color: rgba(0, 0, 0, 0.3);
  }

  & >>> span {
    color: rgba(0, 0, 0, 0.6);
  }

  & >>> span.clickable {
    cursor: pointer;
  }
}
</style>
